/* tslint:disable */
/* eslint-disable */
/**
 * EFood Storefront API
 * This is the EFood Storefront API specification.  Operations are grouped by tags.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../base';
// @ts-ignore
import { Cart } from '../../../../com/telekom-mms/efood/api/model';
// @ts-ignore
import { LanguageId } from '../../../../com/telekom-mms/efood/api/model';
/**
 * XCartApi - axios parameter creator
 * @export
 */
export const XCartApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets order details for the shopping cart.
         * @summary Get order details
         * @param {string} storeId The store identifier
         * @param {LanguageId} [langId] Language identifier. If not specified, the locale parameter will be used. If locale isn\&#39;t specified, then the store default language shall be used.
         * @param {boolean} [refreshAvailabilities] Flag to indicate that the availabilities of the order items needs to be calculated again.
         * @param {'xml' | 'json'} [responseFormat] The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json.
         * @param {number} [pageNumber] Page number. Valid values are positive integers starting at 1. Use pageNumber with pageSize.
         * @param {number} [pageSize] Page size. Used to limit the amount of data returned by a query. Valid values are integers starting with 1. Use pageSize with pageNumber.
         * @param {'EUR' | 'USD'} [currency] The currency code to use for example, currency&#x3D;USD. If no currency code is specified, the store default currency is used.
         * @param {string} [sortOrderItemBy] The sort order of the results for example, sort by orderItemID.
         * @param {'IBM_Summary' | 'IBM_Details'} [profileName] Profile name. Profiles determine the subset of data returned by a query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart: async (storeId: string, langId?: LanguageId, refreshAvailabilities?: boolean, responseFormat?: 'xml' | 'json', pageNumber?: number, pageSize?: number, currency?: 'EUR' | 'USD', sortOrderItemBy?: string, profileName?: 'IBM_Summary' | 'IBM_Details', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getCart', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/cart/@self`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (langId !== undefined) {
                localVarQueryParameter['langId'] = langId;
            }

            if (refreshAvailabilities !== undefined) {
                localVarQueryParameter['refreshAvailabilities'] = refreshAvailabilities;
            }

            if (responseFormat !== undefined) {
                localVarQueryParameter['responseFormat'] = responseFormat;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (sortOrderItemBy !== undefined) {
                localVarQueryParameter['sortOrderItemBy'] = sortOrderItemBy;
            }

            if (profileName !== undefined) {
                localVarQueryParameter['profileName'] = profileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * XCartApi - functional programming interface
 * @export
 */
export const XCartApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = XCartApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets order details for the shopping cart.
         * @summary Get order details
         * @param {string} storeId The store identifier
         * @param {LanguageId} [langId] Language identifier. If not specified, the locale parameter will be used. If locale isn\&#39;t specified, then the store default language shall be used.
         * @param {boolean} [refreshAvailabilities] Flag to indicate that the availabilities of the order items needs to be calculated again.
         * @param {'xml' | 'json'} [responseFormat] The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json.
         * @param {number} [pageNumber] Page number. Valid values are positive integers starting at 1. Use pageNumber with pageSize.
         * @param {number} [pageSize] Page size. Used to limit the amount of data returned by a query. Valid values are integers starting with 1. Use pageSize with pageNumber.
         * @param {'EUR' | 'USD'} [currency] The currency code to use for example, currency&#x3D;USD. If no currency code is specified, the store default currency is used.
         * @param {string} [sortOrderItemBy] The sort order of the results for example, sort by orderItemID.
         * @param {'IBM_Summary' | 'IBM_Details'} [profileName] Profile name. Profiles determine the subset of data returned by a query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCart(storeId: string, langId?: LanguageId, refreshAvailabilities?: boolean, responseFormat?: 'xml' | 'json', pageNumber?: number, pageSize?: number, currency?: 'EUR' | 'USD', sortOrderItemBy?: string, profileName?: 'IBM_Summary' | 'IBM_Details', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCart(storeId, langId, refreshAvailabilities, responseFormat, pageNumber, pageSize, currency, sortOrderItemBy, profileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * XCartApi - factory interface
 * @export
 */
export const XCartApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = XCartApiFp(configuration)
    return {
        /**
         * Gets order details for the shopping cart.
         * @summary Get order details
         * @param {string} storeId The store identifier
         * @param {LanguageId} [langId] Language identifier. If not specified, the locale parameter will be used. If locale isn\&#39;t specified, then the store default language shall be used.
         * @param {boolean} [refreshAvailabilities] Flag to indicate that the availabilities of the order items needs to be calculated again.
         * @param {'xml' | 'json'} [responseFormat] The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json.
         * @param {number} [pageNumber] Page number. Valid values are positive integers starting at 1. Use pageNumber with pageSize.
         * @param {number} [pageSize] Page size. Used to limit the amount of data returned by a query. Valid values are integers starting with 1. Use pageSize with pageNumber.
         * @param {'EUR' | 'USD'} [currency] The currency code to use for example, currency&#x3D;USD. If no currency code is specified, the store default currency is used.
         * @param {string} [sortOrderItemBy] The sort order of the results for example, sort by orderItemID.
         * @param {'IBM_Summary' | 'IBM_Details'} [profileName] Profile name. Profiles determine the subset of data returned by a query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart(storeId: string, langId?: LanguageId, refreshAvailabilities?: boolean, responseFormat?: 'xml' | 'json', pageNumber?: number, pageSize?: number, currency?: 'EUR' | 'USD', sortOrderItemBy?: string, profileName?: 'IBM_Summary' | 'IBM_Details', options?: any): AxiosPromise<Cart> {
            return localVarFp.getCart(storeId, langId, refreshAvailabilities, responseFormat, pageNumber, pageSize, currency, sortOrderItemBy, profileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * XCartApi - object-oriented interface
 * @export
 * @class XCartApi
 * @extends {BaseAPI}
 */
export class XCartApi extends BaseAPI {
    /**
     * Gets order details for the shopping cart.
     * @summary Get order details
     * @param {string} storeId The store identifier
     * @param {LanguageId} [langId] Language identifier. If not specified, the locale parameter will be used. If locale isn\&#39;t specified, then the store default language shall be used.
     * @param {boolean} [refreshAvailabilities] Flag to indicate that the availabilities of the order items needs to be calculated again.
     * @param {'xml' | 'json'} [responseFormat] The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json.
     * @param {number} [pageNumber] Page number. Valid values are positive integers starting at 1. Use pageNumber with pageSize.
     * @param {number} [pageSize] Page size. Used to limit the amount of data returned by a query. Valid values are integers starting with 1. Use pageSize with pageNumber.
     * @param {'EUR' | 'USD'} [currency] The currency code to use for example, currency&#x3D;USD. If no currency code is specified, the store default currency is used.
     * @param {string} [sortOrderItemBy] The sort order of the results for example, sort by orderItemID.
     * @param {'IBM_Summary' | 'IBM_Details'} [profileName] Profile name. Profiles determine the subset of data returned by a query.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof XCartApi
     */
    public getCart(storeId: string, langId?: LanguageId, refreshAvailabilities?: boolean, responseFormat?: 'xml' | 'json', pageNumber?: number, pageSize?: number, currency?: 'EUR' | 'USD', sortOrderItemBy?: string, profileName?: 'IBM_Summary' | 'IBM_Details', options?: any) {
        return XCartApiFp(this.configuration).getCart(storeId, langId, refreshAvailabilities, responseFormat, pageNumber, pageSize, currency, sortOrderItemBy, profileName, options).then((request) => request(this.axios, this.basePath));
    }
}
